import React, { useEffect, useState } from 'react'
import NewsBackground from '../../../assets/backgrounds/similar-resources.svg'
import SectionWithTag, { Side } from '../../../components/SectionWithTag'
import { Color } from '../../../utils/constants'
import { FormattedMessage } from 'react-intl'
import { WP_REST_API_Post } from 'wp-types/index'
import PostSummary from '../../../partials/Post/PostSummary'
import MovingBackground from '../../../partials/MovingBackground/MovingBackground'
import { getCategoryPosts, getResourceCategories } from '../../../utils/api'
import { CategoryType } from '../../../components/Category'

interface SimilarResourcesProps {
  category: CategoryType
  currentPostId?: number
}

const SimilarResources = ({ category, currentPostId }: SimilarResourcesProps) => {
    const [categories, setCategories] = useState<any[]>([])
    const [allPosts, setAllPosts] = useState<WP_REST_API_Post[]>([])
    const [posts, setPosts] = useState<WP_REST_API_Post[]>([])
    useEffect(() => {
        getResourceCategories(setCategories)
    }, [])

    useEffect(() => {
        if (categories.length > 0) {
            getCategoryPosts(setAllPosts, categories)
        }
    }, [categories])

    useEffect(() => {
        if (categories) {
            const currentCategoryId = categories.find((cat) => cat.slug === category)?.id
            if (currentCategoryId) {
                const categoryPosts: WP_REST_API_Post[] =
          currentCategoryId &&
          allPosts.filter(
              (post) => post.id !== currentPostId && post.categories?.includes(currentCategoryId),
          )
                if (categoryPosts?.length >= 3) {
                    setPosts(categoryPosts.slice(0, 3))
                } else {
                    const postsToAdd = 3 - categoryPosts.length
                    const nonCategoryPosts = allPosts
                        .filter((post) => !post.categories?.includes(currentCategoryId))
                        .slice(0, postsToAdd)
                    setPosts([...categoryPosts, ...nonCategoryPosts])
                }
            }
        }
    }, [categories, allPosts, category, currentPostId])

    const addGradient = (post: any) =>
        !(post.acf?.featured_image ?? post._embedded?.['wp:featuredmedia']?.[0]?.['source_url'])

    return (
        <div className='bg-sand'>
            <MovingBackground component={NewsBackground}>
                <div className='py-12 md:py-24 relative pr-0  2xl:max-w-screen-2xl mx-auto'>
                    <SectionWithTag
                        tag={{ id: 'page.resources.similar', color: Color.BLACK }}
                        side={Side.LEFT}
                    >
                        <div>
                            <div className='pt-9 pb-10 md:pb-16'>
                                <FormattedMessage id='page.resources.similar' tagName='h2' />
                            </div>
                            <div className='flex gap-x-10'>
                                {posts.map((post: WP_REST_API_Post) => (
                                    <PostSummary
                                        post={post}
                                        key={`post-${post.id}`}
                                        className='news__post'
                                        color={Color.BLACK}
                                        addGradient={addGradient(post)}
                                    />
                                ))}
                            </div>
                        </div>
                    </SectionWithTag>
                </div>
            </MovingBackground>
        </div>
    )
}

export default SimilarResources
